import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsArduinoComponent } from './simple-icons-arduino.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsArduinoComponent ],
    exports:      [ SimpleIconsArduinoComponent ],
    bootstrap:    []
})
export class SimpleIconsArduinoModule {}
